export default "__VITE_ASSET__80929f7d__"